import { FormEvent, useState } from 'react'
import { useEditor } from '@smartfire/js-block-engine'
import apiFetch from '@wordpress/api-fetch'
import toast from 'react-hot-toast'

export const useOnSubmitAdForm = (path: string, callback?: Function) => {
    const { isEditing } = useEditor()
    const [isLoading, setIsLoading] = useState(false)

    const formHandler = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.stopPropagation()
        if (isEditing) return

        setIsLoading(true)
        const formNode = e.currentTarget
        const formData = new FormData(formNode)

        // Add required sign in formData keys
        Object.entries(formNode).forEach(([key, element]: [any, any]) => {
            if (isNaN(key)) return

            if (element?.required && element?.type !== 'file') {
                formData.append(element.name + '*', element.value)
                formData.delete(element.name)
            }
        })

        // Send post request
        try {
            await apiFetch({
                path: path,
                method: 'POST',
                body: formData,
            })
            setTimeout(() => window.scrollTo(0, 0), 100)
            formNode.reset()
            if (callback) callback()
        } catch (err: any) {
            let message = ''
            Object.entries(err).forEach((entry) => (message += entry[1]))
            toast.error(message)
        } finally {
            setIsLoading(false)
        }
    }

    return {
        isLoading,
        formHandler,
    }
}
